
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/HowItWorks",
      function () {
        return require("private-next-pages/HowItWorks.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/HowItWorks"])
      });
    }
  